export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOAD_PAGE = 'LOAD_PAGE';
export const BREADCRUMB = 'BREADCRUMB';
export const MASTER_DATA = 'MASTER_DATA';
export const EDIT_FORM_DATA = 'EDIT_FORM_DATA';
